window.CartDisclaimer = (function() {
  'use strict';

  let userCountry = null;
  let initialized = false;
  let disclaimerInstances = [];

  // Función para detectar el país del usuario
  function detectUserCountry() {
    return new Promise((resolve) => {
      // Intentar obtener el país desde Shopify (si está disponible)
      if (window.Shopify && window.Shopify.country) {
        resolve(window.Shopify.country);
        return;
      }

      // Intentar obtener el país desde el locale del navegador
      if (navigator.language) {
        const locale = navigator.language.toLowerCase();
        if (locale.includes('ca') || locale.includes('canada')) {
          resolve('CA');
          return;
        }
      }

      // API de geolocalización como fallback (opcional)
      try {
        fetch('https://ipapi.co/country/')
          .then(response => response.text())
          .then(country => {
            resolve(country.toUpperCase());
          })
          .catch(() => {
            // Si falla, asumimos que no es Canadá
            resolve('US');
          });
      } catch (error) {
        resolve('US');
      }
    });
  }

  // Función para mostrar u ocultar disclaimer
  function toggleDisclaimer(disclaimerId, targetCountry) {
    const disclaimerElement = document.getElementById(disclaimerId);
    
    if (!disclaimerElement) {
      return;
    }

    if (userCountry === targetCountry) {
      disclaimerElement.style.display = 'block';
      disclaimerElement.setAttribute('aria-hidden', 'false');
    } else {
      disclaimerElement.style.display = 'none';
      disclaimerElement.setAttribute('aria-hidden', 'true');
    }
  }

  // Función para actualizar todos los disclaimers
  function updateAllDisclaimers() {
    disclaimerInstances.forEach(instance => {
      toggleDisclaimer(instance.id, instance.country);
    });
  }

  // Función de inicialización pública
  function init(disclaimerId, targetCountry) {
    // Agregar esta instancia al array
    disclaimerInstances.push({
      id: disclaimerId,
      country: targetCountry
    });

    // Si ya hemos detectado el país, actualizar inmediatamente
    if (userCountry !== null) {
      toggleDisclaimer(disclaimerId, targetCountry);
      return;
    }

    // Si es la primera vez, detectar el país
    if (!initialized) {
      initialized = true;
      detectUserCountry().then(country => {
        userCountry = country;
        updateAllDisclaimers();
      });
    }
  }

  // Función para forzar la actualización (útil para testing)
  function forceCountry(country) {
    userCountry = country;
    updateAllDisclaimers();
  }

  // API pública
  return {
    init: init,
    forceCountry: forceCountry,
    getUserCountry: function() { return userCountry; }
  };
})();

// Event listener para cart drawer updates
document.addEventListener('DOMContentLoaded', function() {
  // Escuchar cambios en el cart drawer
  const cartDrawer = document.querySelector('[data-cart-drawer-inner]');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Re-inicializar disclaimers si se detectan cambios en el DOM
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.querySelector) {
              const disclaimers = node.querySelectorAll('[data-disclaimer-country]');
              disclaimers.forEach(function(disclaimer) {
                const disclaimerId = disclaimer.id;
                const country = disclaimer.getAttribute('data-disclaimer-country');
                if (disclaimerId && country) {
                  CartDisclaimer.init(disclaimerId, country);
                }
              });
            }
          });
        }
      });
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
}); 